<template>
	<Content :title="'Comprobantes'">
		<Spinner v-if="loading.view"></Spinner>
		<template v-else>
			<Card title="Comprobantes" :bodyClass="'p-0'" :noHeader="true">
				<div class="card-body">
					<h5>Filtros</h5>
					<div class="row">
						<div class="col-xl-3">
							<div class="row">
								<div class="col-xl-6">
									<div class="form-group">
										<label for="" class="form-label">Fecha Inicio</label>
										<InputDatepicker v-model="form.fechaInicio"></InputDatepicker>
									</div>
								</div>
								<div class="col-xl-6">
									<div class="form-group">
										<label for="" class="form-label">Fecha Fin</label>
										<InputDatepicker v-model="form.fechaFin"></InputDatepicker>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-2">
							<div class="form-group">
								<label for="" class="form-label">Agencia</label>
								<InputText v-model="form.agencia"></InputText>
							</div>
						</div>
						<div class="col-xl-1">
							<div class="form-group">
								<label for="" class="form-label">Nro.</label>
								<InputText v-model="form.numeroComprobante" type="number"></InputText>
							</div>
						</div>
						<div class="col-xl-4">
							<div class="row">
								<div class="col-xl-4">
									<div class="form-group">
										<label for="" class="form-label">Tipo de Doc.</label>
										<InputSelect v-model="form.idDocVenta" :options="containers.tiposDoc" label="nombre" :reduce="(opcion) => opcion.idDocVenta"></InputSelect>
									</div>
								</div>
								<div class="col-xl-4">
									<div class="form-group">
										<label for="" class="form-label">Moneda</label>
										<InputSelect v-model="form.idMoneda" :options="containers.monedas" label="sigla" :reduce="(opcion) => opcion.idMoneda"></InputSelect>
									</div>
								</div>
								<div class="col-xl-4">
									<div class="form-group">
										<label for="" class="form-label">Tipo</label>
										<InputSelect v-model="form.tipo" :options="containers.tipos" label="nombre" :reduce="(opcion) => opcion.idTipo"></InputSelect>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-2">
							<div class="form-group">
								<label class="form-label invisible">Sincronización</label>
								<button class="btn btn-primary btn-block" :disabled="loading.sincronizacion || loading.confirmandoSincronizacion" @click="onSincronizarRecientes">
									<i class="fa fa-sync-alt mr-1" :class="{ 'fa-spin': loading.sincronizacion }"></i>
									{{ loading.sincronizacion ? "Sincronizando..." : "Sincronizar recientes" }}
								</button>
							</div>
						</div>
					</div>
				</div>
				<Table2 :columns="columns" :columnID="'idComprobante'" :rows="containers.comprobantes">
					<template #rowactions="{ row }">
						<button class="btn btn-icon btn-xs btn-light-primary mr-2" @click="onShow(row, 0)">
							<i class="fa fa-fw fa-eye"></i>
						</button>
						<BDropdown v-if="row.idComprobanteEstado !== 2" size="xs" variant="outline-secondary" toggle-class="text-decoration-none btn-icon" no-caret boundary="window">
							<template #button-content>
								<i class="fa fa-ellipsis-v"></i>
							</template>
							<BDropdownItemButton v-if="row.idDocVenta <= 2" button-class="py-1 px-3" @click="onShow(row, 2, true)">
								Emitir Nota
							</BDropdownItemButton>

							<BDropdownItemButton v-if="row.idComprobanteEstado <= 2" button-class="py-1 px-3 text-danger" @click="onAnular(row)">
								Anular
							</BDropdownItemButton>
						</BDropdown>
					</template>
					<template #rowfecha="{ val }">
						{{ val | date }}
					</template>
					<template #rowenlace="{ val }">
						<a v-if="val" :href="val" target="_blank" rel="noopener noreferrer">
							<i class="fa fa-fw fa-external-link-alt"></i>
						</a>
					</template>
					<template #rowenlacePdf="{ val }">
						<a v-if="val" :href="val" target="_blank" rel="noopener noreferrer">
							<i class="fa fa-fw fa-external-link-alt"></i>
						</a>
					</template>
				</Table2>
				<BPagination
					v-if="paginacion.total > paginacion.porPagina"
					:value="paginacion.pagina"
					:total-rows="paginacion.total"
					:per-page="paginacion.porPagina"
					:disabled="loading.comprobantes"
					first-number
					last-number
					:limit="6"
					align="center"
					class="mt-5"
					@input="onCambiarPagina"
				></BPagination>
			</Card>

			<ComprobanteModal2 v-if="containers.comprobanteModal.show" :comprobante="containers.comprobanteModal.item" @hide="onHideComprobanteModal"></ComprobanteModal2>
			<ComprobanteAnularModal v-if="containers.comprobanteAnularModal.show" :comprobante="containers.comprobanteAnularModal.item" @hide="onHideComprobanteAnularModal"></ComprobanteAnularModal>
		</template>
	</Content>
</template>

<script>
import InputText from "../../shared/components/InputText.vue";
import { BDropdown, BDropdownItemButton, BPagination } from "bootstrap-vue";
import { debounce } from "../../shared/helpers";

import ComprobanteAnularModal from "../components/ComprobanteAnularModal.vue";
import ComprobanteModal2 from "../components/ComprobanteModal2.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import Table2 from "../../shared/components/Table2.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Card from "../../shared/components/Card.vue";
import Content from "../../shared/components/Content.vue";
export default {
	components: { Content, Card, Spinner, Table2, InputSelect, InputDatepicker, ComprobanteModal2, BDropdown, BDropdownItemButton, BPagination, ComprobanteAnularModal, InputText },
	data() {
		return {
			form: {
				fechaInicio: "",
				fechaFin: "",
				agencia: "",
				numeroComprobante: "",
				idDocVenta: "",
				idMoneda: "",
				tipo: "",
			},
			loading: {
				view: true,
				comprobantes: false,
				confirmandoSincronizacion: false,
				sincronizacion: false,
			},
			paginacion: {
				pagina: 1,
				porPagina: 50,
				total: 0,
				ultimaPagina: 0,
			},
			solicitudComprobantes: 0,
			containers: {
				comprobantes: [],
				tiposDoc: [],
				monedas: [],
				tipos: [],
				comprobanteModal: {
					show: false,
					item: null,
				},
				comprobanteAnularModal: {
					show: false,
					item: null,
				},
			},
		};
	},
	computed: {
		columns() {
			return [
				{
					key: "actions",
					label: "",
					width: 50,
					row_class: "text-center",
				},
				{
					key: "fecha",
					label: "Fecha",
					width: 60,
					head_class: "text-center",
					row_class: "text-center",
				},

				{
					key: "docventa",
					label: "Tipo Doc.",
					width: 80,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "serie",
					label: "Serie",
					width: 50,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "nroComprobante",
					label: "Nro.",
					width: 50,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "estado",
					label: "Estado",
					width: 60,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "items",
					label: "Items",
					width: 40,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "tipo",
					label: "Tipo",
					width: 60,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "codigos",
					label: "Códigos",
					width: 70,
					head_class: "text-center",
				},
				{
					key: "agencia",
					label: "Agencia",
					minWidth: 150,
					head_class: "text-center",
				},
				{
					key: "moneda",
					label: "Moneda",
					width: 60,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "total",
					label: "Total",
					width: 50,
					head_class: "text-center",
					row_class: "text-right",
				},
				{
					key: "igv",
					label: "IGV",
					width: 50,
					head_class: "text-center",
					row_class: "text-right",
				},
				{
					key: "pagotipo",
					label: "Tipo de Pago",
					width: 80,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "enlace",
					label: "Enlace",
					width: 40,
					head_class: "text-center",
					row_class: "text-center",
				},
				{
					key: "enlacePdf",
					label: "PDF",
					width: 40,
					head_class: "text-center",
					row_class: "text-center",
				},
			];
		},
	},
	watch: {
		form: {
			deep: true,
			handler() {
				this.solicitudComprobantes += 1;
				this.onCambiarFiltros();
			},
		},
	},
	async created() {
		try {
			await Promise.all([this.cargarFiltros(), this.cargarComprobantes()]);
		} finally {
			this.loading.view = false;
		}
	},
	methods: {
		escaparHtml(valor) {
			return String(valor ?? "")
				.replace(/&/g, "&amp;")
				.replace(/</g, "&lt;")
				.replace(/>/g, "&gt;")
				.replace(/"/g, "&quot;")
				.replace(/'/g, "&#039;");
		},
		resumenSincronizacion(resultado) {
			const lineas = [
				`Consultados: ${this.escaparHtml(resultado.consultados)}`,
				`Importados: ${this.escaparHtml(resultado.importados)}`,
				`Anulados importados: ${this.escaparHtml(resultado.anulados)}`,
				`No encontrados: ${this.escaparHtml(resultado.noEncontrados)}`,
				`Omitidos: ${this.escaparHtml(resultado.omitidos)}`,
			];
			const detalles = (resultado.detalles || []).filter((detalle) => ["omitido", "existente"].indexOf(detalle.estado) !== -1);

			if (detalles.length) {
				lineas.push("<hr><strong>Comprobantes no procesados:</strong>");

				detalles.forEach((detalle) => {
					const tipo = detalle.tipoComprobante == 1 ? "Factura" : detalle.tipoComprobante == 2 ? "Boleta" : "Comprobante";
					const mensaje = detalle.mensaje || (detalle.estado === "existente" ? "Ya estaba registrado." : "No se pudo procesar.");

					lineas.push(
						`${tipo} ${this.escaparHtml(detalle.serie)}-${this.escaparHtml(detalle.numero)}: ${this.escaparHtml(mensaje)}`
					);
				});
			}

			return lineas.join("<br>");
		},
		async cargarFiltros() {
			try {
				const response = await this.axios.get("/comprobantes/filtros");
				this.containers.tiposDoc = response.data.content.tiposDoc;
				this.containers.monedas = response.data.content.monedas;
				this.containers.tipos = response.data.content.tipos;
			} catch (error) {
				console.error(error?.response || error);
			}
		},
		parametrosComprobantes() {
			const parametros = {
				pagina: this.paginacion.pagina,
				porPagina: this.paginacion.porPagina,
			};

			Object.keys(this.form).forEach((campo) => {
				const valor = this.form[campo];

				if (valor !== "" && valor !== null && valor !== undefined) {
					parametros[campo] = valor;
				}
			});

			return parametros;
		},
		async cargarComprobantes() {
			const solicitud = ++this.solicitudComprobantes;
			this.loading.comprobantes = true;

			try {
				const response = await this.axios.get("/comprobantes", {
					params: this.parametrosComprobantes(),
				});

				if (solicitud !== this.solicitudComprobantes) return;

				response.data.content.forEach((item) => {
					item.row_class = ({ idComprobanteEstado }) => {
						return idComprobanteEstado == 2 ? "table-light-danger" : "";
					};
				});

				this.containers.comprobantes = response.data.content;
				this.paginacion = response.data.paginacion;
			} catch (error) {
				if (solicitud === this.solicitudComprobantes) {
					console.error(error?.response || error);
				}
			} finally {
				if (solicitud === this.solicitudComprobantes) {
					this.loading.comprobantes = false;
				}
			}
		},
		onCambiarFiltros: debounce(function() {
			this.paginacion.pagina = 1;
			this.cargarComprobantes();
		}, 400),
		onCambiarPagina(pagina) {
			if (pagina === this.paginacion.pagina) return;

			this.paginacion.pagina = pagina;
			this.cargarComprobantes();
		},
		async onSincronizarRecientes() {
			if (this.loading.sincronizacion || this.loading.confirmandoSincronizacion) return;

			this.loading.confirmandoSincronizacion = true;
			let confirmacion;

			try {
				confirmacion = await this.$confirm.fire({
					title: "Sincronizar comprobantes recientes",
					text: "Se consultarán en Nubefact hasta diez números siguientes de facturas y boletas. Cada serie se detendrá en el primer número no encontrado.",
					confirmButtonText: "Sincronizar",
				});
			} finally {
				this.loading.confirmandoSincronizacion = false;
			}

			if (!confirmacion.isConfirmed) return;

			this.loading.sincronizacion = true;

			try {
				const response = await this.axios.post("/comprobantes/sincronizar-recientes");
				const resultado = response.data.content;

				await this.$swal.fire({
					title: resultado.omitidos ? "Sincronización completada con advertencias" : "Sincronización completada",
					html: this.resumenSincronizacion(resultado),
					icon: resultado.omitidos ? "warning" : "success",
				});

				await this.cargarComprobantes();
			} catch (error) {
				const contenido = error?.response?.data?.content;

				if (contenido) {
					await this.cargarComprobantes();
					const importados = Number(contenido.importados || 0);
					const textoImportados = importados === 1 ? "Se importó 1 comprobante" : `Se importaron ${this.escaparHtml(importados)} comprobantes`;

					await this.$swal.fire({
						title: importados ? "Sincronización parcial" : "No se completó la sincronización",
						html: `${
							importados
								? `<p>${textoImportados}, pero la sincronización se detuvo para evitar omitir numeraciones pendientes.</p>`
								: "<p>La sincronización se detuvo antes de importar comprobantes.</p>"
						}${this.resumenSincronizacion(contenido)}`,
						icon: importados ? "warning" : "error",
					});

					return;
				}

				await this.$swal.fire({
					title: "No se completó la sincronización",
					text: error?.response?.data?.message || "No fue posible sincronizar los comprobantes.",
					icon: "error",
				});
			} finally {
				this.loading.sincronizacion = false;
			}
		},
		onShow(item, modo = 0, emitirNota = false) {
			this.containers.comprobanteModal.item = { ...item, modo, emitirNota };
			this.containers.comprobanteModal.show = true;
		},
		onAnular(item) {
			this.containers.comprobanteAnularModal.item = item;
			this.containers.comprobanteAnularModal.show = true;
		},
		onHideComprobanteModal(reload) {
			if (reload) {
				window.location.reload();
				return;
			}

			this.containers.comprobanteModal.show = false;
		},
		onHideComprobanteAnularModal(reload) {
			if (reload) {
				window.location.reload();
				return;
			}
			this.containers.comprobanteAnularModal.show = false;
		},
	},
};
</script>

<style></style>
